import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'src/routes/hooks';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import PrioritizationTable from './priotization-table';
const RiskPrioritizationView = () => {
    const searchParams = useSearchParams();
    const token = searchParams.get('token') || localStorage.getItem('authToken') || '';
    console.log('myToken', token)

    const { id } = useParams();
    const [PriotizationViewDetails, setPriotizationViewDetails] = useState();  // New state for incident details

    useEffect(() => {
        getPriotizationViewDetails();
    }, [])

    const getPriotizationViewDetails = async () => {
        const data = await getRequest(endpoints.risk_management.risk_priotization.priotization_Show(id));
        console.log("🚀 ~ getPriotizationViewDetails ~ data:", data)
        setPriotizationViewDetails(data);

    }
    return (
        <PrioritizationTable data={PriotizationViewDetails} />
    );
};
export default RiskPrioritizationView;